import { preparePythonPrediction } from "./python-prediction-request";
import { Firestore } from "firebase/firestore";
import type { FirebaseBackend } from "./firebase-backend";
import { Functions, httpsCallable, HttpsCallable } from "firebase/functions";
import { IMAGE_GENERATION_FROM_URLS } from "./firebase-function-name";
import {
  ImageGenerationFromUrlsRequest,
  ImageGenerationFromUrlsResponse,
} from "../image-generation-from-urls-types";

export class ImageGenerationFromUrlsManager {
  private getCurrentTeamId: () => string | null | undefined;

  private firestore: Firestore;

  private backend: FirebaseBackend;

  private imageGenerationFromUrls: HttpsCallable<
    ImageGenerationFromUrlsRequest,
    ImageGenerationFromUrlsResponse
  >;

  constructor({
    firestore,
    firebaseFunctions,
    backend,
    getCurrentTeamId,
  }: {
    firestore: Firestore;
    firebaseFunctions: Functions;
    backend: FirebaseBackend;
    getCurrentTeamId: () => string | null | undefined;
  }) {
    this.firestore = firestore;
    this.backend = backend;
    this.getCurrentTeamId = getCurrentTeamId;

    this.imageGenerationFromUrls = httpsCallable(firebaseFunctions, IMAGE_GENERATION_FROM_URLS, {
      timeout: 180000,
    });
  }

  async generateImagesFromUrls(
    request: ImageGenerationFromUrlsRequest,
  ): Promise<ImageGenerationFromUrlsResponse> {
    try {
      const pending = await preparePythonPrediction(
        IMAGE_GENERATION_FROM_URLS,
        request,
        this.getCurrentTeamId,
      );
      const response = await this.imageGenerationFromUrls(pending.request);
      await pending.confirm(response.data);
      return response.data;
    } catch {
      console.error("python_prediction_submission_unconfirmed");
      throw new Error("Failed to generate images from urls");
    }
  }
}
